<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1> 키오스크 관리 등록</h1>
      </div>
    </div>
    <!--  기본 정보  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>키오스크 ID</label>
            <ul class="w75">
              <li>
                <span class="forg">키오스크를 등록하면 자동으로 배정됩니다.</span>
              </li>
            </ul>
          </dd>
          <dd>
            <label>키오스크 용도<span class="forg">*</span></label>
            <ul class="w80">
              <div v-for="item in kioskUseScnList ">
                <input
                    class="k-radio"
                    type="radio"
                    name="useScnRef"
                    v-model="kioskInfo.kioskUseScn"
                    :id="`${item.cdId}_useScn`"
                    :value="item.cdId"
                >
                <label :for="`${item.cdId}_useScn`" class="k-radio-label">{{ item.cdNm }} </label>
              </div>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>생성 일시</label>
            <ul class="w75">
              <li>
                <span class="forg">키오스크를 등록하면 자동으로 배정됩니다.</span>
              </li>
            </ul>
          </dd>
          <dd>
            <label>사용 여부</label>
            <ul class="w75">
              <li>
                <kendo-switch
                    ref="kioskUseYnRef"
                    :messages-checked="'on'"
                    :messages-unchecked="'off'"
                    @change="kioskInfo.kioskUseYn = ((kioskInfo.kioskUseYn === 'Y') ? 'N' : 'Y')"
                    :checked="kioskInfo.kioskUseYn === 'Y'"
                >
                </kendo-switch>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <li>
              <label>키오스크 명<span class="forg">*</span></label>
              <ul class="w75">
                <li>
                  <kendo-maskedtextbox
                      class="w75"
                      :class="{'error' : errorTarget === 'kioskNm'}"
                      ref="kioskNmRef"
                      v-model.trim="kioskInfo.kioskNm"
                      maxlength="20"
                      :placeholder="'키오스크명을 입력하세요.'">
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </li>
            <li>
              <label>사업장/거점<span class="forg">*</span></label>
              <ul class="w75">
                <li class="box_flex">
                  <kendo-dropdownlist
                      class="w50"
                      :class="{'error' : errorTarget === 'facility'}"
                      ref="facilityRef"
                      v-model="kioskInfo.facility"
                      :option-label="'사업장을 선택해주세요.'"
                      :data-source="zone1DepthList"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdId'"
                      :index="0"
                      @change="kioskInfo.area=null; kioskInfo.building=null; kioskInfo.floor=null; onChangeFacility();"
                  >
                  </kendo-dropdownlist>
                  <kendo-dropdownlist
                      class="w50 mgl5"
                      :class="{'error' : errorTarget === 'area'}"
                      ref="areaRef"
                      v-model="kioskInfo.area"
                      :option-label="'사업장 선택 후 선택해주세요'"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdId'"
                      @change="kioskInfo.building=null; kioskInfo.floor=null; onChangeArea();"
                      value="0"
                  >
                  </kendo-dropdownlist>
                </li>
              </ul>
            </li>
            <li>
              <label>건물/층<span class="forg">*</span></label>
              <ul class="w75">
                <li class="box_flex">
                  <kendo-dropdownlist
                      class="w50"
                      :class="{'error' : errorTarget === 'building'}"
                      ref="buildingRef"
                      v-model="kioskInfo.building"
                      :option-label="'거점 선택 후 선택해주세요'"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdId'"
                      @change="kioskInfo.floor=null; onChangeBuilding()"
                      value="0"
                  >
                  </kendo-dropdownlist>
                   <kendo-dropdownlist
                      class="w50 mgl5"
                      :class="{'error' : errorTarget === 'floor'}"
                      ref="floorRef"
                      v-model="kioskInfo.floor"
                      :option-label="'건물 선택 후 선택해주세요'"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdId'"
                      :index="0"
                  >
                  </kendo-dropdownlist>
                </li>
              </ul>
            </li>
          </dd>
          <dd>
            <label>키오스크 담당자<span class="forg">*</span></label>
            <ul>
              <li>
                <dd>
                  <span style="width: 50%; text-align: center; ">{{ '관리자' }}</span>
                </dd>
                <dd>
                  <span style="width: 50%; text-align: center; margin-left: 15px">{{ '키오스크 담당자' }}</span>
                </dd>
              </li>
              <li>
                <kendo-listbox id="optional"
                               class="kiosk_admin_option"
                               ref="optionalRef"
                               :draggable="true"
                               :connect-with="'selected'"
                               :drop-sources="['selected']"
                               :data-source="facilityManagerList"
                               :data-text-field="'userNm'"
                               :data-value-field="'unqUserNo'"
                               :toolbar-tools="['transferTo', 'transferFrom', 'transferAllTo', 'transferAllFrom']"
                               style="width: 50%"
                >
                </kendo-listbox>
                <kendo-listbox id="selected"
                               class="kiosk_admin_option"
                               ref="selectedRef"
                               :draggable="true"
                               :connect-with="'optional'"
                               :drop-sources="['optional']"
                               :data-sources="kioskManagerList"
                               :data-text-field="'userNm'"
                               :data-value-field="'unqUserNo'"
                               style="width: 47%; margin-left: 2%"
                >
                </kendo-listbox>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <!--  버전 정보  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>현재 버전<span class="forg">*</span></label>
            <ul class="w75">
              <kendo-dropdownlist
                  class="w75"
                  :class="{'error' : errorTarget === 'lastVersionId'}"
                  ref="versionListRef"
                  v-model="kioskInfo.lastVersionId"
                  :option-label="'현재 버전 선택'"
                  :data-text-field="'versionNm'"
                  :data-value-field="'versionId'"
              >
              </kendo-dropdownlist>
            </ul>
          </dd>
          <dd>
            <label>업데이트 버전 설정</label>
            <ul class="w75">
              <li>
                <span class="forg">키오스크 등록 후 업데이트 버전 설정 가능합니다.</span>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <!--  상단 버튼 영역  -->
    <div class="dblock mgt20">
      <div class="c_t_button_wrap f_l">
        <button class="mid_btn green" @click="onClickAddLocker" >무인보관함 추가</button>
      </div>
      <div class="c_t_button_wrap f_l">
        <button class="mid_btn white" @click="onClickSelectLocker" :disabled="!!!kioskInfo.area" style="margin-left: 10px" >무인보관함 불러오기</button>
      </div>
    </div>
    <!--  무인보관함 정보  -->
    <div v-for="(locker, index) in lockerList" :key="index" class="contents_wrap">
      <div class="f_l" style="margin-top:6px">
        <kendo-button @click="onClickDeleteLocker(locker)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6" style="width:15px">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </kendo-button>
      </div>
      <ul class="filter_list f_r w95">
        <li>
          <dd>
            <label>무인 보관함 명<span class="forg">*</span></label>
            <ul class="w75">
              <kendo-maskedtextbox
                  class="w75"
                  ref="lockerNmRef"
                  v-model.trim="locker.lockerNm"
                  maxlength="20"
                  :placeholder="'무인 보관함 명을 입력하세요.'"
                  :disabled="!!locker.lockerId"
              >
              </kendo-maskedtextbox>
            </ul>
          </dd>
          <dd>
            <label>무인 보관함 위치 설명</label>
            <ul class="w75">
              <kendo-maskedtextbox
                  class="w75"
                  ref="lockerDescRef"
                  v-model.trim="locker.lockerDesc"
                  maxlength="100"
                  :placeholder="'무인 보관함 위치 설명을 입력하세요.'"
              >
              </kendo-maskedtextbox>
            </ul>
          </dd>
          <dd>
            <label>사용 여부<span class="forg">*</span></label>
            <ul class="w75">
              <li>
                <div v-for="item in [{cdId:'Y',cdNm:'사용'},{cdId:'N',cdNm:'미사용'}]">
                  <input
                      class="k-radio"
                      type="radio"
                      :name="`lockerUseYn_`+index"
                      v-model="locker.lockerUseYn"
                      :id="`${item.cdNm}_lockerUseYN_${index}`"
                      :value="item.cdId"
                      :checked="item === lockerList.lockerUseYn">
                  <label :for="`${item.cdNm}_lockerUseYN_${index}`" class="k-radio-label" style="width:100px">{{ item.cdNm }}</label>
                </div>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <!--  버튼 영역  -->
    <div class="button_area w30">
      <ul>
        <li class="w25">
          <button type="button" class="large_btn" @click="redirectToList">목록</button>
        </li>
        <li class="w25">
          <button type="submit" class="large_btn orange" @click="onChangeSave">저장</button>
        </li>
      </ul>
    </div>
    <locker-select-window
        ref="lockerSelectWindowRef"
        :area="kioskInfo.area"
        @selectLocker="selectedLockerAdd"
    ></locker-select-window>
  </section>
</template>
<script>

import { LogisticsCodeDtlMixin, ZoneMixin } from '@/mixin/Mixin'
import DaumPostcodeWindow from '@/components/DaumPostcodeWindow.vue'
import ApiUtil from '@/api/api.util'
import { ListBox } from '@progress/kendo-listbox-vue-wrapper'
import LockerSelectWindow from '@/components/LockerSelectWindow.vue'
import ApiConfig from '@/api/api.config'
import Apiconfig from '@/api/api.config'
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: 'KioskSave',
  components: {
    LockerSelectWindow,
    'kendo-listbox': ListBox
  },
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted () {
    const vm = this
    vm.onChange1Depth('facilityRef')
    vm.onChange3Depth('areaRef')
    vm.onChange4Depth('buildingRef')
    vm.getVersionList()
    vm.getManagerList()
  },
  computed: {},
  methods: {
    // 등록 버튼
    async onChangeSave () {
      const vm = this
      if (vm.validation()) {
        await kendo.confirm('저장 하시겠습니까?').done(
          async function () {
            vm.saveKiosk()
          })
      }
    },
    // 유효성 체크
    validation () {
      const vm = this
      const kioskInfo = vm.kioskInfo

      //필수값 체크
      if (EtnersCommonUtil.isEmpty(kioskInfo.kioskNm)) {
        kendo.alert('키오스크 명을 입력해주세요')
        vm.errorTarget = 'kioskNm'
        return
      }
      if (EtnersCommonUtil.isEmpty(kioskInfo.kioskUseScn)) {
        kendo.alert('키오스크 용도를 선택하세요')
        vm.errorTarget = null
        return
      }
      if (EtnersCommonUtil.isEmpty(kioskInfo.kioskUseYn)) {
        kendo.alert('키오스크 사용 여부를 선택하세요')
        vm.errorTarget = null
        return
      }
      if (EtnersCommonUtil.isEmpty(kioskInfo.facility)) {
        kendo.alert('사업장을 선택하세요')
        vm.errorTarget = 'facility'
        return
      }
      if (EtnersCommonUtil.isEmpty(kioskInfo.area)) {
        kendo.alert('거점을 선택하세요')
        vm.errorTarget = 'area'
        return
      }
      if (EtnersCommonUtil.isEmpty(kioskInfo.building)) {
        kendo.alert('건물을 선택하세요')
        vm.errorTarget = 'building'
        return
      }
      if (EtnersCommonUtil.isEmpty(kioskInfo.floor)) {
        kendo.alert('층을 선택하세요')
        vm.errorTarget = 'floor'
        return
      }
      if (vm.$refs.selectedRef.kendoWidget().dataSource.data().length < 1) {
        kendo.alert('키오스크 담당자를 지정해 주세요')
        vm.errorTarget = null
        return
      }
      if (EtnersCommonUtil.isEmpty(kioskInfo.lastVersionId)) {
        kendo.alert('현재 버전을 선택해 주세요')
        vm.errorTarget = 'lastVersionId'
        return
      }
      if (vm.lockerList.length > 0) {
        for (const locker of vm.lockerList){
          if(EtnersCommonUtil.isEmpty(locker.lockerNm)){
            kendo.alert('무인 보관함 명을 입력해 주세요')
            vm.errorTarget = null
            return
          }
          if(EtnersCommonUtil.isEmpty(locker.lockerUseYn)){
            kendo.alert('무인 보관함 활성화 여부를 선택하세요')
            vm.errorTarget = null
            return
          }
        }
      }
      vm.errorTarget = null
      return true
    },
    // 키오스크 등록 API
    saveKiosk () {
      const vm = this
      const url = `${Apiconfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/kioskSave.json`
      const updateManagerList = vm.$refs.selectedRef.kendoWidget().dataSource.data().map(item => item.unqUserNo);
      const params = {
        loginUserToken: vm.loginUserToken,
        kioskInfo: vm.kioskInfo,
        lockerInfoList: vm.lockerList,
        updateManagerList: updateManagerList,
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        kendo.alert('등록되었습니다.')
        vm.redirectToList()
      })
    },
    // 관리자 목록 호출 API
    getManagerList () {
      const vm = this
      const url = `${Apiconfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/facilityManagerList.json`
      const params = {
        loginUserToken: vm.loginUserToken,
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.facilityManagerList = resultData,
        vm.$refs.selectedRef.kendoWidget().dataSource.data([])
      })
    },
    // 키오스크 버전 정보 호출 API
    getVersionList() {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/versionList.json`

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          this.$Progress.fail()
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.versionList = resultData
        vm.$refs.versionListRef.kendoWidget().setDataSource(vm.versionList)
      })
    },
    // 무인보관함 행 추가
    onClickAddLocker () {
      const vm = this
      if(vm.lockerList.length >= 5){
        kendo.alert('<p>무인보관함은 최대 5개까지 등록 가능합니다.<br>추가 등록은 관리자에게 문의 바랍니다.</p>')
        return false
      }
      vm.lockerList.push({
        lockerNm : null,
        lockerDesc : null,
        lockerUseYn : 'Y',
        index: vm.lockerList.length+1,
      })
    },
    // 무인보관함 행 삭제
    onClickDeleteLocker(locker){
      const vm = this
      kendo.confirm('삭제하시겠습니까?').done(function (){
        vm.lockerList = vm.lockerList.filter(item => (item.index !== locker.index))
        // index reset
        let i=1
        vm.lockerList.forEach(item => { item.index = i++ })
      })
    },
    // 무인보관함 불러오기 버튼
    onClickSelectLocker () {
      const vm = this
      vm.$refs.lockerSelectWindowRef.$refs.kendoWindowRef
        .kendoWidget()
        .center()
        .open()
      vm.$refs.lockerSelectWindowRef.getLockerList()
    },
    // 무인보관함 정보 불러오기
    selectedLockerAdd(data){
      const vm = this
      let lockerExists = vm.lockerList.some(item => item.lockerId === data.lockerId)
      if(vm.lockerList.length >= 5){
        kendo.alert('<p>무인보관함은 최대 5개까지 등록 가능합니다.<br>추가 등록은 관리자에게 문의 바랍니다.</p>')
        return false
      }
      if(lockerExists) {
        kendo.alert('이미 추가된 무인보관함입니다.')
        return false
      }
      vm.lockerList.push({
        lockerId : data.lockerId,
        lockerNm : data.lockerNm,
        lockerDesc : data.lockerDesc,
        lockerUseYn: data.lockerUseYn,
        index : vm.lockerList.length+1,
      })
    },
    // 목록으로 이동
    redirectToList () {
      this.$router.push({
        name: 'KioskList'
      })
    },
    // facility 에 따른 area 세팅
    onChangeFacility () {
      const vm = this
      vm.onChange1Depth('facilityRef')
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
      vm.$refs.buildingRef.kendoWidget().setDataSource('')
      vm.$refs.floorRef.kendoWidget().setDataSource('')
    },
    // area 에 따른 building 세팅
    onChangeArea () {
      const vm = this
      const area = vm.$refs.areaRef.kendoWidget().value()
      // zone4DepthMap 의 키 값이 'area%'이라면, zone4DepthList 로 추가한다.
      vm.zone4DepthList = []
      for (let [key, valueList] of vm.zone4DepthMap.entries()) {
        if (key.indexOf(area) === 0) {
          vm.zone4DepthList = [...vm.zone4DepthList, ...valueList]
        }
      }
      vm.$refs.buildingRef.kendoWidget().setDataSource(vm.zone4DepthList)
      vm.$refs.floorRef.kendoWidget().setDataSource('')
    },
    // building 에 따른 floor 세팅
    onChangeBuilding () {
      const vm = this
      vm.onChange4Depth('buildingRef')
      vm.$refs.floorRef.kendoWidget().setDataSource(vm.zone5DepthList)
    },
  },

  data () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      //kiosk 기본 정보
      kioskInfo: {
        kioskNm: null,
        kioskUseYn: 'Y',
        facility: null,
        area: null,
        building: null,
        floor: null,
        kioskUseScn: '01', // 키오스크 용도
      },
      errorTarget: null,
      lockerList: [],
      areaLockerList: [],
      facilityManagerList: [],
      kioskManagerList: [],
      updateManagerList: [],
    }
  }
}
</script>
